<template>
	<b-modal ref="modalCommentaire">
		<template slot="modal-header" slot-scope="{ close }">
			<i class="btn btn-link my-auto" @click="close()"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /></i>
			<h2 class="mx-auto my-auto">{{ $t('monte.stock_semence.commentaire_stallion') }}</h2>
		</template>
		<template slot="default">
			<p v-if="horse" class="font-weight-bold">{{ horse.horse_nom }}</p>
			<textarea class="form-control" rows="5" :placeholder="$t('formulaire.votre_commentaire')" v-model="commentaire"></textarea>
	    </template>
		<template slot="modal-footer" class="justify-content-center">
			<div class="text-center">
				<b-button @click="save" variant="primary" class="rounded-pill" :disabled="processing">
					{{ $t('global.enregistrer') }}
					<font-awesome-icon v-if="processing" :icon="['fal', 'sync']" :spin="processing"/>
					<font-awesome-icon v-else :icon="['fal', 'save']" class="ml-1"/>
				</b-button>
				<b-button @click="$refs.modalCommentaire.hide()" class="rounded-pill ml-1">
					{{ $t('global.annuler') }} <font-awesome-icon :icon="['fal', 'times']" class="ml-1"/>
				</b-button>
			</div>
		</template>
	</b-modal>
</template>

<script type="text/javascript">
	import StockSemence from "@/mixins/StockSemence"

	export default {
		name: 'ModalCommentaireStallionTiers',
		mixins: [StockSemence],
		props: ['tiers_id'],
		data () {
			return {
				horse: null,
				commentaire: '',
				processing: false
			}
		},

		methods: {
			openModal(stock) {
				this.horse = stock.horse
				this.commentaire = stock.commentaire_stallion || ''
				this.$refs.modalCommentaire.show()
			},

			async save() {
				this.processing = true
				const result = await this.saveCommentaireStallionTiers(this.tiers_id, this.horse.horse_id, this.commentaire)
				this.processing = false

				if(!result) {
					this.failureToast("toast.info_save_failed")
					return
				}

				this.$refs.modalCommentaire.hide()
				this.$emit("done", true)
			}
		}
	}
</script>
